import { Injectable } from "@angular/core";
import { NetworkService } from "../common/network.service";
import { Router } from "@angular/router";

@Injectable()
export class MainServiceService {


  constructor(private networkService: NetworkService,
    public router: Router) {

  }

  saveTime(body: any) {
    return this.networkService.post("api/useTime", body, null, "bearer");
  }


}


